/**
 * Atajos del editor (fase 9). Puro para testearlo: recibe lo mínimo del evento.
 *  - Esc            → deseleccionar todo y cerrar popovers
 *  - Cmd/Ctrl+Enter → correr todo
 *  - Cmd/Ctrl+D     → duplicar la selección
 *  - Cmd/Ctrl+Z     → deshacer · Cmd/Ctrl+Shift+Z → rehacer
 *  - V H T C P N    → herramientas de la barra (sin modificador)
 *  - ?              → tabla de atajos
 * Nunca actúa mientras se escribe en un input/textarea/select (salvo Esc).
 * Supr/Backspace los maneja React Flow (`deleteKeyCode`).
 */
export type AccionAtajo = 'deseleccionar' | 'correr' | 'duplicar' | 'deshacer' | 'rehacer' | 'ayuda' | `tool:${Herramienta}` | null;

export type Herramienta = 'seleccionar' | 'mano' | 'texto' | 'comentar' | 'dibujar' | 'nota';

const LETRAS: Record<string, Herramienta> = { v: 'seleccionar', h: 'mano', t: 'texto', c: 'comentar', p: 'dibujar', n: 'nota' };

export interface TeclaMinima {
  key: string;
  metaKey: boolean;
  ctrlKey: boolean;
  /** `tagName` del elemento con foco (INPUT, TEXTAREA, SELECT, DIV…). */
  tag: string;
  /** contentEditable con foco. */
  editable?: boolean;
  shiftKey?: boolean;
}

export function accionDeTecla(t: TeclaMinima): AccionAtajo {
  if (t.key === 'Escape') return 'deseleccionar';
  const escribiendo = t.editable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(t.tag.toUpperCase());
  if (escribiendo) return null;
  const mod = t.metaKey || t.ctrlKey;
  if (mod && t.key === 'Enter') return 'correr';
  if (mod && t.key.toLowerCase() === 'd') return 'duplicar';
  if (mod && t.key.toLowerCase() === 'z') return t.shiftKey ? 'rehacer' : 'deshacer';
  if (!mod && t.key === '?') return 'ayuda';
  if (!mod && !t.shiftKey && t.key.length === 1 && LETRAS[t.key.toLowerCase()]) return `tool:${LETRAS[t.key.toLowerCase()]}`;
  return null;
}
